/* eslint-disable react/prop-types */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import ShapeMenuContent from './ShapeMenuContent';
// We're using a Component-as-prop pattern here so that the <Dropdown.Menu /> component can be customized but with the ref forwarded and shape-menu class added for styles.
/**
 * {closeDropdownOnSelect} - in case there's a change of mind to close shapemenu when a menu is selected in other component usage
 */ export default /*#__PURE__*/ forwardRef(function ShapeMenu(_param, ref) {
    var data = _param.data, DropdownMenuComponent = _param.DropdownMenuComponent, className = _param.className, showShapeName = _param.showShapeName, areaType = _param.areaType, popupTrigger = _param.popupTrigger, closeMenu = _param.closeMenu, _param_closeDropdownOnSelect = _param.closeDropdownOnSelect, closeDropdownOnSelect = _param_closeDropdownOnSelect === void 0 ? true : _param_closeDropdownOnSelect, props = _object_without_properties(_param, [
        "data",
        "DropdownMenuComponent",
        "className",
        "showShapeName",
        "areaType",
        "popupTrigger",
        "closeMenu",
        "closeDropdownOnSelect"
    ]);
    return /*#__PURE__*/ React.createElement(DropdownMenuComponent, _object_spread({
        ref: ref,
        className: classNames(className, 'MeatballDropdown shape-menu'),
        closeDropdownOnSelect: closeDropdownOnSelect
    }, props), /*#__PURE__*/ React.createElement(ShapeMenuContent, {
        showShapeName: showShapeName,
        areaType: areaType,
        data: data,
        popupTrigger: popupTrigger,
        closeMenu: closeMenu,
        closeDropdownOnSelect: closeDropdownOnSelect
    }));
});
